import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useAppSelector, useAuthentication } from '@pkg/hooks';

import { DEP_YATIVERSE } from '@app/routes';
import { useNavigationStore } from '@app/store/zustand';

import { NavButton } from '../../NavButton';
import { Toggle } from '../../Toggle';
import { YatPicker } from '../../YatPicker';
import { collapseTransition, groupAnimation, itemAnimation } from '../../animations';
import { Buttons, Collapse, Collapseable, StyledButton } from '../../styles';

interface SectionProps {
    isOpen: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    isStatic?: boolean;
    isMinimized?: boolean;
}

export const YativerseSection = ({ isOpen, setIsOpen, isStatic, isMinimized }: SectionProps) => {
    const { showLegacyYativerse } = useAppSelector((state) => state.featureFlags.features);

    const location = useLocation();
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);
    const { handleAuthenticate } = useAuthentication();
    const toggleMobileMenu = useNavigationStore((state) => state.toggleMobileMenu);

    useEffect(() => {
        if (location.pathname.startsWith(DEP_YATIVERSE) && setIsOpen) {
            setIsOpen(true);
        }
    }, [location.pathname, setIsOpen]);

    const yatPickerMarkup =
        isMinimized &&
        (isRegisteredUser ? (
            <YatPicker />
        ) : (
            <StyledButton size="xsmall" onClick={handleAuthenticate}>
                Sign up <span>or</span> Log in
            </StyledButton>
        ));

    return (
        <>
            <Collapseable>
                <Toggle
                    emoji="🖖"
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    isStatic={isStatic}
                    aria-expanded={isOpen}
                    aria-controls="sidenav-section-yativerse"
                    showAlways={yatPickerMarkup}
                    titleLink="/yativerse"
                >
                    Yats
                </Toggle>

                <Collapse
                    variants={groupAnimation}
                    initial={false}
                    animate={isOpen ? 'open' : 'closed'}
                    transition={collapseTransition}
                    aria-labelledby="sidenav-section-yativerse"
                    $allowOverflow={isMinimized}
                >
                    <Buttons>
                        {showLegacyYativerse && (
                            <NavButton
                                to="/yativerse"
                                variants={itemAnimation}
                                isActive={location.pathname.startsWith(DEP_YATIVERSE)}
                                onClick={() => toggleMobileMenu(false)}
                            >
                                Yativerse
                            </NavButton>
                        )}

                        <NavButton
                            to="/artifacts?goBackEnabled=1"
                            variants={itemAnimation}
                            onClick={() => toggleMobileMenu(false)}
                        >
                            Artifacts
                        </NavButton>

                        <NavButton to="/create" variants={itemAnimation} onClick={() => toggleMobileMenu(false)}>
                            Create Yats
                        </NavButton>
                    </Buttons>
                </Collapse>
            </Collapseable>
        </>
    );
};
